// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"282":"f85fc17e","323":"2b1de056","535":"41efa7bd","632":"ea3b20f2","641":"ea3b20f2","751":"41efa7bd","841":"ea3b20f2"}[chunkId] + ".chunk.css";
};